import React from "react";
import {formatDate, formatDateTime, readableDate} from "../../utils";
import { Button } from "@allxsmith/bestax-bulma";



export default function PartOrderRow({partOrder, onDelete, view}){
    let dateCreated = new Date(partOrder.date_created)
    return (
        <tr
            className="clickable small-row-black"
            onClick={() => window.open(`/editpartorder/${partOrder.id}`, "_self")}
            key={partOrder.id}
        >
            <td>{partOrder.id}</td>
            <td>{readableDate(formatDate(dateCreated))}</td>
            <td>{partOrder.customer ? partOrder.customer.display_name : ""}</td>
            <td>{partOrder.customer_vehicle}</td>
            <td>{partOrder.customer_vehicle_vin}</td>
            <td>{partOrder.order_number}</td>
            <td>{partOrder.description}</td>
            <td>{partOrder.status}</td>
            <td>{formatDateTime(new Date(partOrder.date_time_created))}</td>
            {view !== "complete" &&
                <td onClick={e => e.stopPropagation()}>
                    <Button
                        color={"danger"}
                        onClick={() => onDelete(partOrder)}
                    >
                        X
                    </Button>
                </td>
            }
        </tr>
    )
}